module.exports = __webpack_public_path__ + "kasasa.png?ed6d334ed8c2501be84764e3541d7d8e";